export default __webpack_public_path__ + "static/media/angpao-cn.b391b4e5.webp";